import { render } from "./PapSmearConventional.vue?vue&type=template&id=d573536a&scoped=true"
import script from "./PapSmearConventional.vue?vue&type=script&lang=js"
export * from "./PapSmearConventional.vue?vue&type=script&lang=js"

import "./PapSmearConventional.vue?vue&type=style&index=0&id=d573536a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d573536a"]])

export default __exports__